import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubtractCircleBold = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "subtract-circle" }), /* @__PURE__ */ _jsx("path", { d: "M12,23.5A11.5,11.5,0,1,0,.5,12,11.513,11.513,0,0,0,12,23.5ZM6,11H18a1,1,0,0,1,0,2H6a1,1,0,0,1,0-2Z" })]
});
export default SvgSubtractCircleBold;
